// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__1VH75","fixedWidth":"Container_fixedWidth__iOmc9","fullWidth":"Container_fullWidth__269Wq"};